
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Kohlapurtopunecab() {



  const cardData =
  {
    keyword: 'Kolhapur to Pune Cab',
    heading: 'SHREE Tours & Travels: Kolhapur to Pune Cab',
    headingDescription: 'SHREE Tours & Travels offers a reliable Kolhapur to Pune Cab service, ensuring a smooth and comfortable journey. Whether you are traveling for business, leisure, or a return trip home, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Kolhapur to Pune travel experience.',

    top: 'Top Places to Visit in Pune  with SHREE Tours & Travels',

    "topPlaces": [
      {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is an iconic historical fortification in Pune, built in 1732 as the residence of the Peshwas of the Maratha Empire. The grand entrance, Delhi Darwaza, leads visitors into the remains of a once-majestic palace, known for its intricate wooden carvings and sprawling gardens. Although much of it was destroyed in a fire in 1828, the structure still stands as a symbol of Pune's rich history. The fort is also famous for its rumored paranormal activities, making it an intriguing spot for history buffs and adventure seekers."
      },
      {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is a stunning piece of architecture built in 1892 by Sultan Muhammed Shah Aga Khan III. This palace holds great significance in Indian history as it served as a prison for Mahatma Gandhi, Kasturba Gandhi and other freedom fighters during the Quit India Movement. The palace now functions as a museum, showcasing rare photographs, memorabilia and personal items of Gandhi. The lush green lawns and Italian arches add to the beauty of this national heritage site, making it a must-visit for history lovers."
      },
      {
        "title": "Sinhagad Fort",
        "description": "Perched atop the Sahyadri Hills, Sinhagad Fort is a historic fortress that played a crucial role in various battles, including the famous Battle of Sinhagad in 1670. The fort offers breathtaking views of the surrounding landscapes and is a favorite trekking destination for adventure enthusiasts. At the top, visitors can explore remnants of old fortifications, temples and memorials while enjoying traditional Maharashtrian snacks like Kanda Bhaji and Pithla Bhakri. The fort’s cool climate and rich history make it a perfect weekend getaway."
      },
      {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune, dedicated to Lord Ganesha. The temple was built by a sweet merchant, Dagdusheth Halwai, in memory of his late son. The idol of Lord Ganesha is adorned with gold ornaments and attracts thousands of devotees, especially during the Ganesh Chaturthi festival. The temple is known for its vibrant atmosphere, devotional music and grand celebrations that showcase the deep spiritual and cultural roots of Pune."
      },
      {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum houses a fascinating collection of over 20,000 artifacts, including musical instruments, sculptures, paintings and antique household items from different parts of India. Established by Dr. Dinkar Kelkar in memory of his son, the museum provides insights into India’s diverse artistic heritage. One of the highlights is the Mastani Mahal, a reconstructed section of the original palace of Mastani, the wife of Peshwa Bajirao I. The museum is a paradise for art lovers and history enthusiasts."
      },
      {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city from an elevation of 2,100 feet. The hilltop is home to the Parvati Temple, dedicated to Goddess Parvati and Lord Shiva. The temple complex also includes shrines for Lord Ganesha, Lord Vishnu and Kartikeya. The climb up 103 steps is rewarded with a peaceful ambiance, making it a great spot for meditation, photography and witnessing beautiful sunrises and sunsets."
      },
      {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Pune is a globally renowned spiritual retreat dedicated to the teachings of Osho Rajneesh. The ashram offers a variety of meditation programs, wellness workshops and relaxation therapies. With its tranquil gardens, serene meditation halls and Zen-inspired architecture, the ashram attracts visitors from around the world seeking inner peace and spiritual growth. The unique blend of traditional and modern meditation techniques makes it a one-of-a-kind experience."
      },
      {
        "title": "Pune Okayama Friendship Garden",
        "description": "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a Japanese-style landscape garden inspired by the Korakuen Garden in Okayama, Japan. Spread over 10 acres, the garden features beautifully designed ponds, bridges, waterfalls and lush greenery, creating a tranquil and picturesque setting. It’s an ideal place for nature lovers, photographers and families looking for a peaceful escape within the city."
      },
      {
        "title": "Pataleshwar Cave Temple",
        "description": "The Pataleshwar Cave Temple is an ancient rock-cut cave temple dedicated to Lord Shiva. Carved out of a single basalt rock in the 8th century, this temple is reminiscent of the famous Ellora Caves. The temple complex features a massive Nandi bull, intricate carvings and a circular stone courtyard. Its historical and architectural significance, coupled with a serene atmosphere, makes it a hidden gem in Pune’s cultural landscape."
      },
      {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, located about 20 km from Pune, is a popular weekend spot known for its scenic beauty and cool breeze. The dam supplies water to Pune city and is surrounded by lush greenery, making it an excellent picnic and photography location. Nearby attractions like Sinhagad Fort and Panshet Dam add to its appeal. Visitors can enjoy street food, leisurely walks and a peaceful escape from city life."
      }
    ],


    "services": [
      {
        "name": "Kolhapur to Pune Taxi",
        "description": "Travel comfortably with our Kolhapur to Pune taxi service. Our well-maintained fleet and experienced drivers ensure a smooth and hassle-free journey from Kolhapur to Pune, whether it's for business or leisure."
      },
      {
        "name": "Kolhapur to Pune Cab Service",
        "description": "Looking for a reliable Cab service from Kolhapur to Pune? We offer both one-way and round-trip Cab options, ensuring a stress-free and comfortable journey with affordable rates and professional drivers."
      },
      {
        "name": "Kolhapur to Pune One-Way Taxi",
        "description": "Need a one-way taxi from Kolhapur to Pune? Book our one-way taxi service for a convenient, comfortable and affordable ride without any hidden charges. Our drivers ensure a timely and safe journey."
      },
      {
        "name": "Kolhapur to Pune Round Trip Cab",
        "description": "Planning a round trip from Kolhapur to Pune? Our round-trip Cab service offers the flexibility of traveling to and from Pune at your convenience, ensuring a smooth and enjoyable journey both ways."
      },
      {
        "name": "Affordable Kolhapur to Pune Cab",
        "description": "Get affordable and reliable Cab services from Kolhapur to Pune without compromising on comfort. Enjoy a seamless and cost-effective ride with our budget-friendly options tailored to meet your travel needs."
      },
      {
        "name": "Private Taxi for Pune from Kolhapur",
        "description": "Book a private taxi for your journey from Kolhapur to Pune. Enjoy privacy, comfort and a hassle-free ride with a professional driver, tailored to your schedule and travel preferences."
      },
      {
        "name": "Pune Tour from Kolhapur by Cab",
        "description": "Explore Pune from Kolhapur with our comfortable Cab service. Whether you're visiting popular tourist spots or just traveling for business, our experienced drivers and well-maintained vehicles ensure a smooth ride."
      },
      {
        "name": "Group Travel from Kolhapur to Pune",
        "description": "Traveling with a group? Our spacious Cabs are perfect for group travel from Kolhapur to Pune. Enjoy a comfortable ride with ample space for luggage and a smooth, enjoyable journey for everyone."
      },
      {
        "name": "Book Kolhapur to Pune Car",
        "description": "Rent a car for your journey from Kolhapur to Pune with ease. Choose from a variety of vehicles, including sedans, SUVs and larger cars, to make your trip more comfortable and convenient."
      },
      {
        "name": "Kolhapur to Pune Cab Booking",
        "description": "Easily book your Cab from Kolhapur to Pune through our online booking system. Enjoy a reliable and timely service with professional drivers and well-maintained vehicles."
      },
      {
        "name": "Kolhapur to Pune Road Trip",
        "description": "Plan a scenic road trip from Kolhapur to Pune with our Cab service. Enjoy a comfortable journey through beautiful landscapes, with experienced drivers ensuring a smooth and enjoyable ride."
      },
      {
        "name": "Pune Sightseeing by Cab",
        "description": "Explore Pune's best attractions with our sightseeing Cab service. Our experienced drivers will take you to all the must-visit locations in Pune, ensuring a comfortable and memorable sightseeing experience."
      },
      {
        "name": "Kolhapur to Pune Luxury Taxi",
        "description": "Experience luxury travel from Kolhapur to Pune with our premium taxi service. Choose from high-end vehicles like Innova Crysta or luxury sedans and enjoy a plush and comfortable ride."
      },
      {
        "name": "Pune to Kolhapur Cab Hire",
        "description": "Looking to hire a Cab for your journey from Pune to Kolhapur? We offer reliable and well-maintained Cabs, providing comfortable travel with professional drivers for a seamless experience."
      }
    ],
    "tableData": [
      ["- Kolhapur to Pune Taxi", "- Kolhapur to Pune Cab Service"],
      ["- Kolhapur to Pune One-Way Taxi", "- Kolhapur to Pune Round Trip Cab"],
      ["- Affordable Kolhapur to Pune Cab", "- Private Taxi for Pune from Kolhapur"],
      ["- Pune Tour from Kolhapur by Cab", "- Group Travel from Kolhapur to Pune"],
      ["- Book Kolhapur to Pune Car", "- Kolhapur to Pune Cab Booking"],
      ["- Kolhapur to Pune Road Trip", "- Pune Sightseeing by Cab"],
      ["- Kolhapur to Pune Luxury Taxi", "- Pune to Kolhapur Cab Hire"]
    ],



    whychoose: [
      {
        "WhyChooseheading": "Comfortable and Scenic Drive",
        "WhyChoosedescription": "Our Kolhapur to Pune Cab service offers a comfortable and scenic drive, allowing you to enjoy the picturesque views along the route. Whether you're traveling for business or leisure, we ensure a smooth and relaxing journey in our air-conditioned vehicles with ample space."
      },
      {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the best routes from Kolhapur to Pune, ensuring you reach your destination safely and on time. They focus on your comfort and safety, making sure your journey is smooth and worry-free."
      },
      {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer affordable and transparent pricing for your Kolhapur to Pune Cab ride. Our rates are competitive, with no hidden charges. Whether you're booking a one-way trip or round-trip, we provide you with the best value for money, ensuring an economical ride without compromising quality."
      },
      {
        "WhyChooseheading": "Well-Maintained Vehicles",
        "WhyChoosedescription": "All our vehicles are well-maintained and regularly serviced to ensure they are in top condition. Our fleet is equipped with all the necessary amenities to provide a safe and comfortable ride, making your trip from Kolhapur to Pune pleasant and stress-free."
      },
      {
        "WhyChooseheading": "Easy and Quick Booking Process",
        "WhyChoosedescription": "Booking your Kolhapur to Pune Cab is quick and easy with SHREE Tours & Travels. You can book online through our user-friendly platform or contact our customer service team for assistance. We make sure that the booking process is seamless and convenient."
      },
      {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "We offer 24/7 availability for your Kolhapur to Pune Cab needs. Whether you're traveling early in the morning or late at night, we are available to accommodate your schedule. Our round-the-clock service ensures that you can book your ride whenever you need it."
      },
      {
        "WhyChooseheading": "Local Insights and Recommendations",
        "WhyChoosedescription": "Our drivers are not just skilled in driving but are also knowledgeable about the local routes, culture and attractions between Kolhapur and Pune. They can provide valuable recommendations for sightseeing and dining spots along the way, enhancing your travel experience."
      },
      {
        "WhyChooseheading": "Customer Satisfaction Guarantee",
        "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our top priority. We are committed to ensuring that your Kolhapur to Pune Cab ride is comfortable, punctual and enjoyable. With our dedication to providing excellent service, we guarantee a pleasant and hassle-free experience."
      }
    ]


















  }
  const faqData = [
    {
      question: "How can I book a Cab from Kolhapur to Pune?",
      answer: "You can easily book your Kolhapur to Pune Cab through our website or by calling our customer service for assistance."
    },
    {
      question: "What types of Cabs do you offer for the Kolhapur to Pune route?",
      answer: "We offer a variety of vehicles for the Kolhapur to Pune journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
      question: "Are the rental rates from Kolhapur to Pune inclusive of fuel?",
      answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
      question: "Can I book a Cab for a one-way trip from Kolhapur to Pune?",
      answer: "Yes, we offer one-way rental options for your Kolhapur to Pune trip."
    },
    {
      question: "Do you provide drivers with the rental Cab for the Kolhapur to Pune trip?",
      answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
      question: "What is your cancellation policy for a Kolhapur to Pune Cab booking?",
      answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
      question: "What payment methods do you accept for the Kolhapur to Pune Cab booking?",
      answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
      question: "Are the vehicles insured for the Kolhapur to Pune trip?",
      answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
      question: "Can I request a child seat for my Cab from Kolhapur to Pune?",
      answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
      question: "What is your contact information for booking a Cab from Kolhapur to Pune?",
      answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
  ];

  const testimonialsData = [
    {
      text: 'The ride from Kolhapur to Pune was amazing! The driver was professional and the vehicle was in great condition.',
      name: 'Mr. Sameer Patil',
    },
    {
      text: 'I had a smooth and comfortable journey with SHREE Tours & Travels. The driver was friendly and the car was perfect for the trip.',
      name: 'Miss. Rupal Shah',
    }
  ];





















  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Kolhapur Cab",
      link: "/Pune-to-Kolhapur-Cab",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Mumbai Cab",
      link: "/Pune-to-Mumbai-Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Sangli Cab",
      link: "/Pune-to-Sangli-Cab",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "/Pune-to-Bhimashankar-Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to Shirdi Cab",
      link: "/Pune-to-Shirdi-Cab",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Nashik Cab",
      link: "/Pune-to-Nashik-Cab",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune Airport pickup and Drop",
      link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune To Mumbai Airport Cab",
      link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai To Pune Cab",
      link: "/Mumbai-To-Pune-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Mumbai To Kolhapur Cab",
      link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Mumbai To Shirdi Cab",
      link: "/Mumbai-To-Shirdi-Cab",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Mumbai To Nashik Cab",
      link: "/Mumbai-To-Nashik-Cab",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Mumbai Airport To Pune Cab",
      link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Kolhapur To Pune Cab",
      link: "/Kolhapur-To-Pune-Cab",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Kolhapur To Mumbai Cab",
      link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Sangli To Pune Cab",
      link: "/Sangli-To-Pune-Cab",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "One Way Taxi in Pune",
      link: "/One-Way-Taxi-in-Pune",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Best Cab service in Pune",
      link: "/Best-Cab-Service-in-Pune",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Outstation Cabs Pune",
      link: "/Outstation-Cabs-Pune",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Swift Dzire Hire in Pune",
      link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Xcent Hyundai On Rent in Pune",
      link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Nexa Ciaz On Rent in Pune",
      link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Honda City On Rent In Pune",
      link: "/Honda-City-On-Rent-In-Pune",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Ertiga On Rent in Pune",
      link: "/Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Innova Cab for Outstation in Pune",
      link: "/Innova-Cab-for-Outstation-in-Pune",
    },
  ];



  const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

  ];


  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "SHREE Tours & Travels",
    "description": "Book a comfortable and reliable Kolhapur to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Your office address here",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411001",
      "addressCountry": "IN"
    },
    "telephone": "+91-9594917913",
    "url": "https://shreetoursandtravels.in",
    "logo": "https://shreetoursandtravels.in/img/logo.jpg",
    "image": [
      "https://shreetoursandtravels.in/img/kolhapur-to-pune-cab.jpg",
      "https://shreetoursandtravels.in/img/pune-trip-cab.jpg"
    ],
    "priceRange": "₹2500 - ₹4000",
    "offers": {
      "@type": "Offer",
      "url": "https://shreetoursandtravels.in/kolhapur-to-pune-cab-service",
      "priceCurrency": "INR",
      "price": 3000,
      "priceValidUntil": "2025-12-31"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": 4.6,
      "reviewCount": 1000
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Vishal Patil"
        },
        "datePublished": "2024-11-15",
        "reviewBody": "The ride from Kolhapur to Pune was fantastic. The driver was professional and the Cab was clean and comfortable. I highly recommend this service."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Neha Rao"
        },
        "datePublished": "2024-11-20",
        "reviewBody": "Wonderful service! The trip from Kolhapur to Pune was smooth and hassle-free. Will definitely use it again!"
      }
    ],
    "serviceArea": {
      "@type": "Place",
      "name": "Kolhapur to Pune Cab Service",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 16.7047,  // Kolhapur latitude
        "longitude": 74.2434  // Kolhapur longitude
      }
    },
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceUrl": "https://shreetoursandtravels.in/kolhapur-to-pune-cab-service"
    },
    "keywords": "Kolhapur to Pune Taxi, Kolhapur to Pune Cab Service, Kolhapur to Pune One-Way Taxi, Kolhapur to Pune Round Trip Cab, Affordable Kolhapur to Pune Cab, Private Taxi for Pune from Kolhapur, Pune Tour from Kolhapur by Cab, Group Travel from Kolhapur to Pune, Book Kolhapur to Pune Car, Kolhapur to Pune Cab Booking, Kolhapur to Pune Road Trip, Pune Sightseeing by Cab, Kolhapur to Pune Luxury Taxi, Pune to Kolhapur Cab Hire"
  };

  return (
    <div>
      <GoogleAnalytics/>
      <Helmet>
        <title>Kolhapur to Pune Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
        <meta name="description" content="Book a comfortable and reliable Kolhapur to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
        <meta name="keywords" content="Kolhapur to Pune Taxi, Kolhapur to Pune Cab Service, Kolhapur to Pune One-Way Taxi, Kolhapur to Pune Round Trip Cab, Affordable Kolhapur to Pune Cab, Private Taxi for Pune from Kolhapur, Pune Tour from Kolhapur by Cab, Group Travel from Kolhapur to Pune, Book Kolhapur to Pune Car, Kolhapur to Pune Cab Booking, Kolhapur to Pune Road Trip, Pune Sightseeing by Cab, Kolhapur to Pune Luxury Taxi, Pune to Kolhapur Cab Hire" />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>

      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/16.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>

              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Kohlapurtopunecab;